import { OffersGiftCardApiClient } from '@fourthwall/services/dist/OffersGiftCardApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useOfferGiftCardCreationMutation = createMutationHook(
  OffersGiftCardApiClient.createOfferGiftCard,
  {
    mutationKey: ['offerGiftCardCreation'],
  },
)
